// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","childParent":"footer_childParent__whftq","child":"footer_child__MKNJC","madeBy":"footer_madeBy__slKhh"};